<template>
  <a class="navbar-item"
     @click="perform"
     href="javascript:void(0);">Logout</a>
</template>

<script>
  import {api, utils} from '../../helpers/'

  export default {
    name: 'Logout',
    methods: {
      perform () {
        const modal = this.$loading.open()
        api.logout()
          .then(() => {
            utils.success('Logout effettuato.', modal)
            api.setAuthorization(null)
            this.$router.push({name: 'Home'})
          })
          .catch(errors => utils.errors(errors, modal))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/actions/Logout.vue